import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  Grid,
  Hidden
} from '@material-ui/core';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { withStyles } from '@material-ui/core/styles';
import { createBrowserHistory } from "history";

function TelemedicineBanner(props) {
  const {
    hasTelemedicineUrl,
    classes: { telemedicineBanner },
  } = props;
  
  const customHistory = createBrowserHistory();

  return (
    <Hidden smDown>
      { !hasTelemedicineUrl && (
        (customHistory.location.pathname === '/admin/practices') ?
          <Grid container justifyContent="center" className={telemedicineBanner}>
            <Grid container item sm={12} justifyContent="center" wrap="nowrap">
              <div>
                Click the purple phone button <AddIcCallIcon /> in the "Telemedicine" column for your row to get set up with Telemedicine visits.
            </div>
            </Grid>
          </Grid>
        :
          <Grid container justifyContent="center" className={telemedicineBanner}>
            <Grid container item sm={12} justifyContent="center" wrap="nowrap">
              <div>
                Want to set up telemedicine appointments? It's easy and free with
                Doxy! <a href={'/admin/practices'}>Click here</a> to get set up.
              </div>
            </Grid>
          </Grid>
      )}
    </Hidden>
  )
}

const styles = {
  telemedicineBanner: {
    padding: '10px',
    backgroundColor: '#a86ff7',
  },
};

export default withRouter(withStyles(styles)(TelemedicineBanner));
